var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "redirect" }, [
    _c(
      "div",
      { staticClass: "gradient-panel" },
      [
        _c("sfi-divider", [
          _c("span", { staticClass: "center step-text" }, [
            _vm._v(_vm._s(_vm.findYourBillTitle))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-area" }, [
          _vm.hasImage
            ? _c("div", { staticClass: "grid-x" }, [
                _c("div", { staticClass: "cell small-12 medium-8" }, [
                  _c("h2", { attrs: { id: "redirectTitle" } }, [
                    _vm._v(_vm._s(_vm.redirectTitle))
                  ]),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "redirectMessage" } }, [
                    _vm._v(_vm._s(_vm.redirectMessage))
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "button primary-orange fixed flex-child-auto expanded-for-small-only",
                      attrs: {
                        name: _vm.redirectButtonAnalyticsName,
                        id: "redirectButton"
                      },
                      on: { click: _vm.redirectBtn }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.redirectButton) +
                          "\n        "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._m(0)
              ])
            : _c("div", { staticClass: "grid-x" }, [
                _c("div", { staticClass: "cell small-12 variable-height" }, [
                  _c("h2", { attrs: { id: "redirectTitle" } }, [
                    _vm._v(_vm._s(_vm.redirectTitle))
                  ]),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "redirectMessage" } }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.redirectMessage) +
                        "\n            "
                    ),
                    _c("div", { attrs: { id: "redirectNote" } }, [
                      _c(
                        "a",
                        {
                          attrs: { name: _vm.redirectButtonAnalyticsName },
                          on: { click: _vm.redirectBtn }
                        },
                        [_vm._v(_vm._s(_vm.redirectButton))]
                      ),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.redirectNote) +
                          "\n            "
                      )
                    ])
                  ])
                ])
              ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell hide-for-small-only medium-4" }, [
      _c("img", { attrs: { src: require("@/assets/flamingos-rule.svg") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5669d73b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5669d73b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RedirectPage.vue
// module id = null
// module chunks = 